/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Request_FailedInputs */

const fr_auth_reset_request_failed = /** @type {(inputs: Auth_Reset_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de confirmer la demande de réinitialisation. Réessayez.`)
};

const en_auth_reset_request_failed = /** @type {(inputs: Auth_Reset_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not confirm the password-reset request. Try again.`)
};

/**
* | output |
* | --- |
* | "Could not confirm the password-reset request. Try again." |
*
* @param {Auth_Reset_Request_FailedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_request_failed = /** @type {((inputs?: Auth_Reset_Request_FailedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Request_FailedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_request_failed(inputs)
	return fr_auth_reset_request_failed(inputs)
});